export default class NetworkingUser {
  public static readonly SET_COUNT = "NETWORKING_USER_SET_COUNT";
  public static readonly SET_DATA = "NETWORKING_USER_SET_DATA";
  public static readonly SET_STATUS = "NETWORKING_USER_SET_STATUS";
  public static readonly SET_ERROR = "NETWORKING_USER_SET_ERROR";
  public static readonly CLEAR = "NETWORKING_USER_CLEAR";

  public static setCount(data: any) {
    return {
      data,
      type: NetworkingUser.SET_COUNT,
    };
  }

  public static setData(data: any) {
    return {
      data,
      type: NetworkingUser.SET_DATA,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: NetworkingUser.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: NetworkingUser.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: NetworkingUser.CLEAR,
    };
  }
}
